import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null
    },
    role: null,
    office: null,
    officeString: null,
    email: null,
    firstname: null,
    is_online: null
  },
  getters: {
    user (state) {
      return this.state.user
    },
    role (state) {
      return this.state.role
    },
    office (state) {
      return this.state.office
    },
    email (email) {
      return this.state.email
    },
    officeString (state) {
      return this.state.officeString
    },
    firstname (state) {
      return this.state.firstname
    },
    is_online (state) {
      return this.state.is_online
    }
  },
  mutations: {
    SET_LOGGED_IN (state, value) {
      this.state.user.loggedIn = true
    },
    SET_USER (state, data) {
      this.state.user.data = data
    },
    SET_ROLE_OFFICE (state, payload) {
      this.state.role = payload.role
      this.state.office = payload.office
      this.state.officeString = payload.officeString
      this.state.email = payload.email
      this.state.firstname = payload.firstname
      this.state.is_online = payload.is_online
    },
    SET_IS_USER_ONLINE (state, payload) {
      this.state.is_online = payload.is_online
    },
    DESTROY_DATA (state) {
      this.state.role = null
      this.state.email = null
      this.state.firstname = null
      this.state.is_online = null
      this.state.office = null
      this.state.user.loggedIn = false
      this.state.user.data = null
    }
  },
  actions: {
    fetchUser ({ commit }, user) {
      commit('SET_LOGGED_IN', user !== null)
      if (user) {
        commit('SET_USER', {
          displayName: user.displayName,
          email: user.email
        })
      } else {
        commit('SET_USER', null)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js